import { isAuthenticatedCustomer } from '@ori/auth';
import { formatToken, getHeaders, ATP_CLUSTER_ID, CUSTOMER_TYPE_ID, USE_PRODUCT_DATA_CACHING, USE_PRODUCTS_SERVICE, VISITOR_SEGMENT } from '@ori/fetching';
import { ApiClient } from '@ori/global-api-client-react';
import { getAtpClusterId } from "./getAtpClusterId";
import { getCustomerInfo } from "./getCustomerInfo";
/**
 * Utility function to generate request headers for customer segmentation. Returns object with headers.
 */
export var getSegmentationHeaders = async function getSegmentationHeaders(_ref) {
  var abortController = _ref.abortController,
    sourceAppName = _ref.sourceAppName,
    atpClusterId = _ref.atpClusterId,
    language = _ref.language,
    customerId = _ref.customerId,
    globalApiUrl = _ref.globalApiUrl,
    tenant = _ref.tenant,
    token = _ref.token,
    _ref$useProductDataCa = _ref.useProductDataCaching,
    useProductDataCaching = _ref$useProductDataCa === void 0 ? true : _ref$useProductDataCa,
    _ref$useProductsServi = _ref.useProductsService,
    useProductsService = _ref$useProductsServi === void 0 ? true : _ref$useProductsServi;
  var headers = getHeaders({
    sourceAppName: sourceAppName,
    language: language,
    customerId: customerId,
    tenant: tenant,
    token: token
  });
  headers[USE_PRODUCT_DATA_CACHING] = useProductDataCaching;
  headers[USE_PRODUCTS_SERVICE] = useProductsService;
  if (isAuthenticatedCustomer(customerId)) {
    var client = new ApiClient({
      baseUrl: globalApiUrl,
      language: language,
      tenant: tenant,
      token: formatToken(token)
    });
    var atpCluster = atpClusterId !== null && atpClusterId !== void 0 ? atpClusterId : await getAtpClusterId({
      abortController: abortController,
      client: client,
      customerId: customerId
    });
    var _await$getCustomerInf = await getCustomerInfo({
        abortController: abortController,
        client: client,
        customerId: customerId
      }),
      customerTypeId = _await$getCustomerInf.customerTypeId,
      visitorSegment = _await$getCustomerInf.visitorSegment;
    if (typeof atpCluster === 'number') {
      headers[ATP_CLUSTER_ID] = atpCluster;
    }
    if (typeof customerTypeId === 'number') {
      headers[CUSTOMER_TYPE_ID] = customerTypeId;
    }
    if (visitorSegment) {
      headers[VISITOR_SEGMENT] = visitorSegment;
    }
  }
  return headers;
};
//# sourceMappingURL=getSegmentationHeaders.js.map